// Lives in a .ts file so Fast Refresh isn't invalidated by mixed exports in the .tsx Provider.
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "@/lib/msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Module-level flag: true while MSAL is handling initialization/redirect.
// Used by apiErrorHandler to suppress 401-triggered logouts during auth setup.
export let isMsalInitializing = true;

export function setMsalInitializingDone() {
  isMsalInitializing = false;
}
